/* eslint-disable react/no-danger */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import HelpVideoModal from 'components/molecules/help_video_modal';
import DocumentsList from 'components/organisms/documents_list';
import { ApplicationState } from 'store';
import {
  DocumentData,
  DocumentsGroup,
  DocumentsState,
  DocumentsTypes,
} from 'store/modules/documents_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import ModalAddDocument from 'components/atoms/modal_add_document';
import DocumentsSearchForm from 'components/molecules/documents_search_form';
import { downLoadFiles, getDocumentsGroups, sendEmail } from 'services/actions/documents_count';
import { getDocuments } from 'store/modules/documents_store/actions';
import SquareLoader from 'components/atoms/square_loader';
import NotificationDocuments from 'components/atoms/notification_documents';
import tabId from 'services/tabId';
import { ServicesSubscriptionState } from 'store/modules/service_subscription_store/types';
import createTrack from 'services/actions/tracker_actions';
import { ProportionalSaleTypes } from 'store/modules/proportional_sale_simulation_store/types';
import Loader from 'components/atoms/loader';
import ModalAuthenticateDocument from 'components/atoms/modal_authenticate_document';
import OpenTutorial from 'components/atoms/open_tutorial';
import ModalWarningAdditional from 'components/atoms/modal_warning_additional';
import { openSupportChat } from 'services/support_chat';

interface DocumentsProps {
  dados: any;
}

const Documents = (props: DocumentsProps) => {
  const { dados } = props;
  const dispatch = useDispatch();
  const { servicesSubscriptions } = useSelector<ApplicationState, ServicesSubscriptionState>(
    (state) => state.storage.servicesSubscriptions,
  );
  const [modalVideoOpened, setModalVideoOpened] = useState<boolean>(false);
  const [modalAuthenticateOpened, setModalAuthenticateOpened] = useState<boolean>(false);
  const [notification, setNotification] = useState<boolean>(false);
  const [sendToEmail, setSendToEmail] = useState<boolean>(false);
  const [sendToEmailModal, setSendToEmailModal] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [searchBarOpened, setSearchBarOpened] = useState<boolean>(true);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [hideUnavailableDocuments, setHideUnavailableDocuments] = useState<boolean>(false);
  const [documentGroupList, setDocumentGroupList] = useState<Array<DocumentsGroup>>([]);
  const [email, setEmail] = useState<string>('');
  const [blockedTool, setBlockedTool] = useState<boolean>(
    !servicesSubscriptions?.Documents?.current_signature,
  );
  const [messageEmail, setMessageEmail] = useState<string>('');
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const [squareLoaderEmail, setSquareLoaderEmail] = useState<boolean>(false);
  const [showDocumentsLimitMsg, setShowDocumentsLimitMsg] = useState<boolean>(false);
  const [buyNow, setBuyNow] = useState<boolean>(false);
  const [selectedDocuments, setSelectedDocuments] = useState<Array<number>>([]);
  const [currentDocumentId, setCurrentDocumentId] = useState<string>('');
  const [showModalWarningAdditional, setShowModalWarningAdditional] = useState<boolean>(false);
  const [documentSelectedForPreview, setDocumentSelectedForPreview] = useState<DocumentData | null>(
    null,
  );

  const { documents, request, documents_list } = useSelector<ApplicationState, DocumentsState>(
    (state) => state.session.documents,
  );

  useEffect(() => {
    setBlockedTool(
      (!servicesSubscriptions?.Documents?.current_signature && !profile?.in_sample) ||
        servicesSubscriptions?.Documents?.service_paralyzed,
    );
  });

  useEffect(() => {
    if (!servicesSubscriptions?.Documents) return;

    setShowDocumentsLimitMsg(
      !servicesSubscriptions?.Documents?.current_signature &&
        !!servicesSubscriptions?.Documents?.in_trial_period &&
        !profile?.in_sample,
    );
  }, [servicesSubscriptions]);

  useEffect(() => {
    dispatch({
      type: ProportionalSaleTypes.DADOS_PROPORTIONAL_SALE,
      dados,
      servico: [3],
    });
  }, [buyNow]);

  useEffect(() => {
    document.title = 'Gerenciar Documentos - ConLicitação';
    (async () => {
      setDocumentGroupList(await getDocumentsGroups());
      if (profile.clientId !== profile.currentCompany[tabId()])
        dispatch(getDocuments({ companyId: profile.currentCompany[tabId()] }));
      else
        dispatch(
          getDocuments({
            cnpj: documents_list?.current_cnpj ? documents_list?.current_cnpj : profile?.cnpj,
          }),
        );
    })();
  }, []);

  useEffect(() => {
    setSelectedDocuments([]);
  }, [documents]);

  useEffect(() => {
    if (!documents_list?.message_view) return;

    setTimeout(() => {
      dispatch({ type: DocumentsTypes.ALERT_TIME });
    }, 3000);
    request?.save_doc_database?.loaded && setShowModal(false);
  }, [documents_list?.message_view]);

  useEffect(() => {
    if (profile.clientId !== profile.currentCompany[tabId()])
      dispatch(getDocuments({ companyId: profile.currentCompany[tabId()] }));
    else {
      dispatch(
        getDocuments({
          cnpj: documents_list?.current_cnpj ? documents_list?.current_cnpj : profile?.cnpj,
        }),
      );
    }
  }, [request?.save_doc_database?.loaded, profile.currentCompany[tabId()]]);

  const onlyDigits = (value?: string | null) => value?.match(/\d+/g)?.join('') || '';

  const getSelectedCompany = () => {
    const isRepresentant = profile?.representant;
    const cnpj = onlyDigits(documents_list?.current_cnpj || profile?.cnpj);
    const monitoredCompany = documents_list?.monitored_companies?.find(
      (company) => onlyDigits(company?.monitored_company) === cnpj,
    );
    const companyId = isRepresentant
      ? monitoredCompany?.client_id || profile.currentCompany[tabId()]
      : profile?.clientId;

    return { isRepresentant, cnpj, companyId };
  };

  const filterSelectedDocuments = () => {
    const { isRepresentant, cnpj, companyId } = getSelectedCompany();
    return documents
      ?.filter((document) =>
        selectedDocuments.includes(Number(document?.id) || Number(document?.default?.id)),
      )
      .map((document) => {
        return {
          isRepresentant,
          cnpj: cnpj ? Number(cnpj) : null,
          companyId: companyId ? Number(companyId) : null,
          is_aws: document?.is_aws,
          fileUrl: document?.fileUrl,
          name: document?.name,
          id: Number(document?.default?.id) || Number(document?.id),
        };
      });
  };

  const handleSendToEmail = () => {
    setSquareLoaderEmail(true);
    (async () => {
      const { cnpj } = getSelectedCompany();

      const response = await sendEmail(filterSelectedDocuments(), email, cnpj);
      response?.status === 200 && setSquareLoaderEmail(false);
      setTimeout(() => {
        setSendToEmail(false);
        setMessageEmail(response?.data?.message);
      }, 1000);
    })();
  };

  const DocumentsLimitMsg = () => {
    return (
      <div className="row my-4">
        <div className="col-12 pl-md-4 pl-3">
          <div className="card shadow">
            <div className="card-body p-2 d-md-flex justify-content-between align-items-center text-center text-md-right">
              <span>
                <div
                  dangerouslySetInnerHTML={{
                    __html: servicesSubscriptions?.Documents?.status_message || '-',
                  }}
                />
              </span>
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={() => {
                  createTrack('Contratar - Documentos');
                  setBuyNow(true);
                }}
              >
                Saiba como contratar
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (request?.get_documents?.loading) return <Loader />;

  return (
    <>
      <DocumentsSearchForm
        setSearchBarOpened={setSearchBarOpened}
        searchBarOpened={searchBarOpened}
        setHideUnavailableDocuments={setHideUnavailableDocuments}
        hideUnavailableDocuments={hideUnavailableDocuments}
        documentGroupList={documentGroupList}
      />
      <div
        className={`col-12 py-4 ${
          searchBarOpened ? 'col-lg-9 offset-lg-3 offset-0 pl-md-5 pl-3' : 'col-lg-12'
        }`}
      >
        {blockedTool && !request?.get_documents?.loading && (
          <div className="row justify-content-center align-items-center mb-5">
            <div className="col-md-12 pl-md-4 pl-3">
              <div className="text-center bg-white border border-secondary rounded p-4">
                <p>
                  <i className="big-icon material-icons mb-2">error_outline</i>
                </p>
                <p className="mb-0">
                  Você não poderá adicionar novos documentos, gerar declarações ou ter os documentos
                  atualizados.
                </p>
                <p className="mt-0">
                  Para contratar a ferramenta completa, entre em contato com um consultor.
                </p>
                {servicesSubscriptions?.Documents?.service_paralyzed ? (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      openSupportChat();
                    }}
                  >
                    Falar com consultor
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                      createTrack('Contratar - Documentos');
                      setBuyNow(true);
                    }}
                  >
                    Contratar Documentos
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-12 pl-md-4 pl-3">
            <div className="d-md-flex d-block align-items-center">
              <h4 className="mb-1 mr-3 font-weight-bold">Gerenciar Documentos</h4>
              <OpenTutorial type="container" source="documents" />
              <div className="ml-md-auto ml-0 mr-1">
                <button
                  type="button"
                  className="btn btn-primary btn-sm mr-1 mb-md-0 mb-2"
                  title="Notificações"
                  onClick={() => setNotification(!notification)}
                >
                  Notificações
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-sm mr-1 mb-md-0 mb-2 tour-documents-add-btn"
                  title={
                    blockedTool && !request?.get_documents?.loading
                      ? 'Disponível na versão paga'
                      : 'Seleciona um documetno'
                  }
                  onClick={() => setShowModal(true)}
                  disabled={blockedTool && !request?.get_documents?.loading}
                >
                  Adicionar documento
                </button>
                <a
                  href="/modelos-documentos"
                  className="btn btn-success btn-sm mb-md-0 mb-2 tour-documents-generator-btn"
                  title="Gerador de declarações"
                  target="_blank"
                  rel="noreferrer"
                >
                  Gerador de declarações
                </a>
              </div>
            </div>
            {notification && <NotificationDocuments />}
            {documents_list?.message_view && (
              <div
                className={`alert ${documents_list?.class_success_or_failure} alert-dismissible fade show text-center mt-4`}
                role="alert"
              >
                {documents_list?.message}
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}
            {messageEmail !== '' && (
              <div
                className="alert alert-success alert-dismissible fade show text-center mt-4"
                role="alert"
              >
                {messageEmail}
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="row mb-1 mt-3">
          <div className="col-md-12 pl-md-4 pl-3">
            <small className="w-100 d-block">
              * Documentos que não possuem data de validade são atualizados a cada{' '}
              <strong>90 dias</strong>. Verifique se no edital existem excepcionalmente regras
              estabelecendo prazos menores.
            </small>
            <small className="w-100 d-block">
              ** Para participação em licitações através da Filial inclua os documentos da Matriz,
              especialmente documentos relativos a regularidade fiscal, trabalhista, falência e
              recuperação judicial.
            </small>
          </div>
        </div>
        <div className="row">
          <div className="col-12 pl-md-4 pl-3">
            <hr className="my-2" />
          </div>
        </div>
        {showDocumentsLimitMsg && DocumentsLimitMsg()}
        <div className="row mb-1 pt-4">
          <div className="col-md-12 pl-md-4 pl-3">
            <div className="d-md-flex d-block align-items-center mb-3">
              <p className="mb-md-0">
                {selectedDocuments.length > 0 ? (
                  <>
                    <strong>{selectedDocuments.length}</strong> documento(s) selecionado(s) de um
                    total de <strong>{documents?.length}</strong> listado(s).
                  </>
                ) : (
                  <>
                    Listando <strong>{documents?.length}</strong> documento(s)
                  </>
                )}
              </p>
              <div className="ml-md-auto ml-0 mr-1 d-flex" role="toolbar">
                <button
                  type="button"
                  className="btn btn-primary btn-sm mr-1 mb-md-0 mb-2 d-flex align-items-center"
                  title=""
                  onClick={() => {
                    const docsForDownload = filterSelectedDocuments();
                    const stateSp = documents?.find((doc) => doc?.default?.state === 'SP');
                    const docFalenciaExist = docsForDownload.find((doc) =>
                      doc.name.includes('Falência'),
                    );
                    if (stateSp && docFalenciaExist) {
                      setShowModalWarningAdditional(true);
                      if (sendToEmailModal) setSendToEmailModal(false);
                    } else {
                      downLoadFiles(docsForDownload, setDownloadLoading);
                    }
                  }}
                  disabled={selectedDocuments?.length === 0 || downloadLoading}
                  data-placement="bottom"
                >
                  Download
                  {downloadLoading && (
                    <div className="ml-2">
                      <SquareLoader customClass="authenticate-document-button" />
                    </div>
                  )}
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-sm mr-1 mb-md-0 mb-2 tour-documents-add-btn"
                  title="Selecione um documento"
                  disabled={selectedDocuments?.length === 0}
                  onClick={() => {
                    const docsForDownload = filterSelectedDocuments();
                    const stateSp = documents?.find((doc) => doc?.default?.state === 'SP');
                    const docFalenciaExist = docsForDownload.find((doc) =>
                      doc.name.includes('Falência'),
                    );
                    if (stateSp && docFalenciaExist && !sendToEmailModal) {
                      setShowModalWarningAdditional(true);
                      setSendToEmailModal(true);
                    } else {
                      setSendToEmail(!sendToEmail);
                    }
                  }}
                >
                  Enviar por e-mail
                </button>
              </div>
            </div>
          </div>
        </div>
        {sendToEmail && (
          <div className="row justify-content-end">
            <div className="col-4">
              <div className="card mb-3">
                <div className="card-body">
                  <h6 className="card-title font-weight-bold d-flex justify-content-between align-items-center">
                    Enviar por e-mail
                    <button
                      type="button"
                      className="btn btn-sm btn-link position-relative"
                      onClick={() => {
                        setSendToEmailModal(false);
                        setSendToEmail(!sendToEmail);
                      }}
                    >
                      x
                    </button>
                  </h6>
                  <div className="row">
                    <div className="col-12">
                      <div className="input-group">
                        <input
                          value={email}
                          type="email"
                          name="login"
                          id="login"
                          className="form-control"
                          placeholder="Email do destinatário"
                          onChange={(e) => setEmail(e.target.value)}
                        />
                        <div className="input-group-append">
                          <button
                            type="submit"
                            className="btn btn-sm btn-primary"
                            disabled={email === '' || squareLoaderEmail}
                            onClick={() => handleSendToEmail()}
                          >
                            Enviar
                          </button>
                        </div>
                      </div>
                      {squareLoaderEmail && (
                        <div className="d-inline-flex position-relative pr-4">
                          Enviando e-mail
                          <SquareLoader customClass="monitoring-message-loader" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-12 pl-md-4 pl-3">
            <div className="card mb-5">
              <div className="card-body p-0 tour-documents-table">
                <DocumentsList
                  documentGroupList={documentGroupList}
                  selectedDocuments={selectedDocuments}
                  setSelectedDocuments={setSelectedDocuments}
                  documents={documents}
                  setModalAuthenticateDocumentoOpened={setModalAuthenticateOpened}
                  setCurrentDocumentId={setCurrentDocumentId}
                  setShowModalWarningAdditional={setShowModalWarningAdditional}
                  setDocumentSelectedForPreview={setDocumentSelectedForPreview}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalWarningAdditional
        setShowModalWarningAdditional={setShowModalWarningAdditional}
        showModalWarningAdditional={showModalWarningAdditional}
        docsForDownload={filterSelectedDocuments()}
        document={documentSelectedForPreview}
        sendToEmailModal={sendToEmailModal}
        setSendToEmail={setSendToEmail}
        setDownloadLoading={setDownloadLoading}
      />
      <ModalAddDocument
        setShowModal={setShowModal}
        showModal={showModal}
        documentGroupList={documentGroupList}
      />
      <ModalAuthenticateDocument
        setShowModal={setModalAuthenticateOpened}
        showModal={modalAuthenticateOpened}
        currentDocumentId={currentDocumentId}
      />
      <HelpVideoModal
        modalVideoOpened={modalVideoOpened}
        setModalVideoOpened={setModalVideoOpened}
        urlVideo="https://player.vimeo.com/video/1142414647"
      />
    </>
  );
};

export default Documents;
